import _classCallCheck from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.slice.js";
import e from "./emitter";
import t from "./filter";
import i from "../filters/getFieldValue";
import s from "../validators/index";

var l = /*#__PURE__*/function () {
  function l(i, s) {
    _classCallCheck(this, l);

    this.elements = {};
    this.ee = e();
    this.filter = t();
    this.plugins = {};
    this.results = new Map();
    this.validators = {};
    this.form = i;
    this.fields = s;
  }

  _createClass(l, [{
    key: "on",
    value: function on(e, t) {
      this.ee.on(e, t);
      return this;
    }
  }, {
    key: "off",
    value: function off(e, t) {
      this.ee.off(e, t);
      return this;
    }
  }, {
    key: "emit",
    value: function emit(e) {
      var _this$ee;

      for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        t[_key - 1] = arguments[_key];
      }

      (_this$ee = this.ee).emit.apply(_this$ee, [e].concat(t));

      return this;
    }
  }, {
    key: "registerPlugin",
    value: function registerPlugin(e, t) {
      if (this.plugins[e]) {
        throw new Error("The plguin ".concat(e, " is registered"));
      }

      t.setCore(this);
      t.install();
      this.plugins[e] = t;
      return this;
    }
  }, {
    key: "deregisterPlugin",
    value: function deregisterPlugin(e) {
      var t = this.plugins[e];

      if (t) {
        t.uninstall();
      }

      delete this.plugins[e];
      return this;
    }
  }, {
    key: "registerValidator",
    value: function registerValidator(e, t) {
      if (this.validators[e]) {
        throw new Error("The validator ".concat(e, " is registered"));
      }

      this.validators[e] = t;
      return this;
    }
  }, {
    key: "registerFilter",
    value: function registerFilter(e, t) {
      this.filter.add(e, t);
      return this;
    }
  }, {
    key: "deregisterFilter",
    value: function deregisterFilter(e, t) {
      this.filter.remove(e, t);
      return this;
    }
  }, {
    key: "executeFilter",
    value: function executeFilter(e, t, i) {
      return this.filter.execute(e, t, i);
    }
  }, {
    key: "addField",
    value: function addField(e, t) {
      var i = Object.assign({}, {
        selector: "",
        validators: {}
      }, t);
      this.fields[e] = this.fields[e] ? {
        selector: i.selector || this.fields[e].selector,
        validators: Object.assign({}, this.fields[e].validators, i.validators)
      } : i;
      this.elements[e] = this.queryElements(e);
      this.emit("core.field.added", {
        elements: this.elements[e],
        field: e,
        options: this.fields[e]
      });
      return this;
    }
  }, {
    key: "removeField",
    value: function removeField(e) {
      if (!this.fields[e]) {
        throw new Error("The field ".concat(e, " validators are not defined. Please ensure the field is added first"));
      }

      var t = this.elements[e];
      var i = this.fields[e];
      delete this.elements[e];
      delete this.fields[e];
      this.emit("core.field.removed", {
        elements: t,
        field: e,
        options: i
      });
      return this;
    }
  }, {
    key: "validate",
    value: function validate() {
      var _this = this;

      this.emit("core.form.validating");
      return this.filter.execute("validate-pre", Promise.resolve(), []).then(function () {
        return Promise.all(Object.keys(_this.fields).map(function (e) {
          return _this.validateField(e);
        })).then(function (e) {
          switch (true) {
            case e.indexOf("Invalid") !== -1:
              _this.emit("core.form.invalid");

              return Promise.resolve("Invalid");

            case e.indexOf("NotValidated") !== -1:
              _this.emit("core.form.notvalidated");

              return Promise.resolve("NotValidated");

            default:
              _this.emit("core.form.valid");

              return Promise.resolve("Valid");
          }
        });
      });
    }
  }, {
    key: "validateField",
    value: function validateField(e) {
      var _this2 = this;

      var t = this.results.get(e);

      if (t === "Valid" || t === "Invalid") {
        return Promise.resolve(t);
      }

      this.emit("core.field.validating", e);
      var i = this.elements[e];

      if (i.length === 0) {
        this.emit("core.field.valid", e);
        return Promise.resolve("Valid");
      }

      var s = i[0].getAttribute("type");

      if ("radio" === s || "checkbox" === s || i.length === 1) {
        return this.validateElement(e, i[0]);
      } else {
        return Promise.all(i.map(function (t) {
          return _this2.validateElement(e, t);
        })).then(function (t) {
          switch (true) {
            case t.indexOf("Invalid") !== -1:
              _this2.emit("core.field.invalid", e);

              _this2.results.set(e, "Invalid");

              return Promise.resolve("Invalid");

            case t.indexOf("NotValidated") !== -1:
              _this2.emit("core.field.notvalidated", e);

              _this2.results.delete(e);

              return Promise.resolve("NotValidated");

            default:
              _this2.emit("core.field.valid", e);

              _this2.results.set(e, "Valid");

              return Promise.resolve("Valid");
          }
        });
      }
    }
  }, {
    key: "validateElement",
    value: function validateElement(e, t) {
      var _this3 = this;

      this.results.delete(e);
      var i = this.elements[e];
      var s = this.filter.execute("element-ignored", false, [e, t, i]);

      if (s) {
        this.emit("core.element.ignored", {
          element: t,
          elements: i,
          field: e
        });
        return Promise.resolve("Ignored");
      }

      var _l = this.fields[e].validators;
      this.emit("core.element.validating", {
        element: t,
        elements: i,
        field: e
      });
      var r = Object.keys(_l).map(function (i) {
        return function () {
          return _this3.executeValidator(e, t, i, _l[i]);
        };
      });
      return this.waterfall(r).then(function (s) {
        var _l2 = s.indexOf("Invalid") === -1;

        _this3.emit("core.element.validated", {
          element: t,
          elements: i,
          field: e,
          valid: _l2
        });

        var r = t.getAttribute("type");

        if ("radio" === r || "checkbox" === r || i.length === 1) {
          _this3.emit(_l2 ? "core.field.valid" : "core.field.invalid", e);
        }

        return Promise.resolve(_l2 ? "Valid" : "Invalid");
      }).catch(function (s) {
        _this3.emit("core.element.notvalidated", {
          element: t,
          elements: i,
          field: e
        });

        return Promise.resolve(s);
      });
    }
  }, {
    key: "executeValidator",
    value: function executeValidator(e, t, i, s) {
      var _this4 = this;

      var _l3 = this.elements[e];
      var r = this.filter.execute("validator-name", i, [i, e]);
      s.message = this.filter.execute("validator-message", s.message, [this.locale, e, r]);

      if (!this.validators[r] || s.enabled === false) {
        this.emit("core.validator.validated", {
          element: t,
          elements: _l3,
          field: e,
          result: this.normalizeResult(e, r, {
            valid: true
          }),
          validator: r
        });
        return Promise.resolve("Valid");
      }

      var a = this.validators[r];
      var d = this.getElementValue(e, t, r);
      var o = this.filter.execute("field-should-validate", true, [e, t, d, i]);

      if (!o) {
        this.emit("core.validator.notvalidated", {
          element: t,
          elements: _l3,
          field: e,
          validator: i
        });
        return Promise.resolve("NotValidated");
      }

      this.emit("core.validator.validating", {
        element: t,
        elements: _l3,
        field: e,
        validator: i
      });
      var n = a().validate({
        element: t,
        elements: _l3,
        field: e,
        l10n: this.localization,
        options: s,
        value: d
      });
      var h = "function" === typeof n["then"];

      if (h) {
        return n.then(function (s) {
          var r = _this4.normalizeResult(e, i, s);

          _this4.emit("core.validator.validated", {
            element: t,
            elements: _l3,
            field: e,
            result: r,
            validator: i
          });

          return r.valid ? "Valid" : "Invalid";
        });
      } else {
        var _s = this.normalizeResult(e, i, n);

        this.emit("core.validator.validated", {
          element: t,
          elements: _l3,
          field: e,
          result: _s,
          validator: i
        });
        return Promise.resolve(_s.valid ? "Valid" : "Invalid");
      }
    }
  }, {
    key: "getElementValue",
    value: function getElementValue(e, t, s) {
      var _l4 = i(this.form, e, t, this.elements[e]);

      return this.filter.execute("field-value", _l4, [_l4, e, t, s]);
    }
  }, {
    key: "getElements",
    value: function getElements(e) {
      return this.elements[e];
    }
  }, {
    key: "getFields",
    value: function getFields() {
      return this.fields;
    }
  }, {
    key: "getFormElement",
    value: function getFormElement() {
      return this.form;
    }
  }, {
    key: "getLocale",
    value: function getLocale() {
      return this.locale;
    }
  }, {
    key: "getPlugin",
    value: function getPlugin(e) {
      return this.plugins[e];
    }
  }, {
    key: "updateFieldStatus",
    value: function updateFieldStatus(e, t, i) {
      var _this5 = this;

      var s = this.elements[e];

      var _l5 = s[0].getAttribute("type");

      var r = "radio" === _l5 || "checkbox" === _l5 ? [s[0]] : s;
      r.forEach(function (s) {
        return _this5.updateElementStatus(e, s, t, i);
      });

      if (!i) {
        switch (t) {
          case "NotValidated":
            this.emit("core.field.notvalidated", e);
            this.results.delete(e);
            break;

          case "Validating":
            this.emit("core.field.validating", e);
            this.results.delete(e);
            break;

          case "Valid":
            this.emit("core.field.valid", e);
            this.results.set(e, "Valid");
            break;

          case "Invalid":
            this.emit("core.field.invalid", e);
            this.results.set(e, "Invalid");
            break;
        }
      }

      return this;
    }
  }, {
    key: "updateElementStatus",
    value: function updateElementStatus(e, t, i, s) {
      var _this6 = this;

      var _l6 = this.elements[e];
      var r = this.fields[e].validators;
      var a = s ? [s] : Object.keys(r);

      switch (i) {
        case "NotValidated":
          a.forEach(function (i) {
            return _this6.emit("core.validator.notvalidated", {
              element: t,
              elements: _l6,
              field: e,
              validator: i
            });
          });
          this.emit("core.element.notvalidated", {
            element: t,
            elements: _l6,
            field: e
          });
          break;

        case "Validating":
          a.forEach(function (i) {
            return _this6.emit("core.validator.validating", {
              element: t,
              elements: _l6,
              field: e,
              validator: i
            });
          });
          this.emit("core.element.validating", {
            element: t,
            elements: _l6,
            field: e
          });
          break;

        case "Valid":
          a.forEach(function (i) {
            return _this6.emit("core.validator.validated", {
              element: t,
              field: e,
              result: {
                message: r[i].message,
                valid: true
              },
              validator: i
            });
          });
          this.emit("core.element.validated", {
            element: t,
            elements: _l6,
            field: e,
            valid: true
          });
          break;

        case "Invalid":
          a.forEach(function (i) {
            return _this6.emit("core.validator.validated", {
              element: t,
              field: e,
              result: {
                message: r[i].message,
                valid: false
              },
              validator: i
            });
          });
          this.emit("core.element.validated", {
            element: t,
            elements: _l6,
            field: e,
            valid: false
          });
          break;
      }

      return this;
    }
  }, {
    key: "resetForm",
    value: function resetForm(e) {
      var _this7 = this;

      Object.keys(this.fields).forEach(function (t) {
        return _this7.resetField(t, e);
      });
      this.emit("core.form.reset", {
        reset: e
      });
      return this;
    }
  }, {
    key: "resetField",
    value: function resetField(e, t) {
      if (t) {
        var _t = this.elements[e];

        var _i = _t[0].getAttribute("type");

        _t.forEach(function (e) {
          if ("radio" === _i || "checkbox" === _i) {
            e.removeAttribute("selected");
            e.removeAttribute("checked");
            e.checked = false;
          } else {
            e.setAttribute("value", "");

            if (e instanceof HTMLInputElement || e instanceof HTMLTextAreaElement) {
              e.value = "";
            }
          }
        });
      }

      this.updateFieldStatus(e, "NotValidated");
      this.emit("core.field.reset", {
        field: e,
        reset: t
      });
      return this;
    }
  }, {
    key: "revalidateField",
    value: function revalidateField(e) {
      this.updateFieldStatus(e, "NotValidated");
      return this.validateField(e);
    }
  }, {
    key: "disableValidator",
    value: function disableValidator(e, t) {
      return this.toggleValidator(false, e, t);
    }
  }, {
    key: "enableValidator",
    value: function enableValidator(e, t) {
      return this.toggleValidator(true, e, t);
    }
  }, {
    key: "updateValidatorOption",
    value: function updateValidatorOption(e, t, i, s) {
      if (this.fields[e] && this.fields[e].validators && this.fields[e].validators[t]) {
        this.fields[e].validators[t][i] = s;
      }

      return this;
    }
  }, {
    key: "setFieldOptions",
    value: function setFieldOptions(e, t) {
      this.fields[e] = t;
      return this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this8 = this;

      Object.keys(this.plugins).forEach(function (e) {
        return _this8.plugins[e].uninstall();
      });
      this.ee.clear();
      this.filter.clear();
      this.results.clear();
      this.plugins = {};
      return this;
    }
  }, {
    key: "setLocale",
    value: function setLocale(e, t) {
      this.locale = e;
      this.localization = t;
      return this;
    }
  }, {
    key: "waterfall",
    value: function waterfall(e) {
      return e.reduce(function (e, t, i, s) {
        return e.then(function (e) {
          return t().then(function (t) {
            e.push(t);
            return e;
          });
        });
      }, Promise.resolve([]));
    }
  }, {
    key: "queryElements",
    value: function queryElements(e) {
      var t = this.fields[e].selector ? "#" === this.fields[e].selector.charAt(0) ? "[id=\"".concat(this.fields[e].selector.substring(1), "\"]") : this.fields[e].selector : "[name=\"".concat(e, "\"]");
      return [].slice.call(this.form.querySelectorAll(t));
    }
  }, {
    key: "normalizeResult",
    value: function normalizeResult(e, t, i) {
      var s = this.fields[e].validators[t];
      return Object.assign({}, i, {
        message: i.message || (s ? s.message : "") || (this.localization && this.localization[t] && this.localization[t].default ? this.localization[t].default : "") || "The field ".concat(e, " is not valid")
      });
    }
  }, {
    key: "toggleValidator",
    value: function toggleValidator(e, t, i) {
      var _this9 = this;

      var s = this.fields[t].validators;

      if (i && s && s[i]) {
        this.fields[t].validators[i].enabled = e;
      } else if (!i) {
        Object.keys(s).forEach(function (i) {
          return _this9.fields[t].validators[i].enabled = e;
        });
      }

      return this.updateFieldStatus(t, "NotValidated", i);
    }
  }]);

  return l;
}();

export default function r(e, t) {
  var i = Object.assign({}, {
    fields: {},
    locale: "en_US",
    plugins: {}
  }, t);
  var r = new l(e, i.fields);
  r.setLocale(i.locale, i.localization);
  Object.keys(i.plugins).forEach(function (e) {
    return r.registerPlugin(e, i.plugins[e]);
  });
  Object.keys(s).forEach(function (e) {
    return r.registerValidator(e, s[e]);
  });
  Object.keys(i.fields).forEach(function (e) {
    return r.addField(e, i.fields[e]);
  });
  return r;
}
export { l as Core };